import { render, staticRenderFns } from "./PaymentStats.vue?vue&type=template&id=4c045cde&scoped=true&"
import script from "./PaymentStats.vue?vue&type=script&lang=js&"
export * from "./PaymentStats.vue?vue&type=script&lang=js&"
import style0 from "./PaymentStats.vue?vue&type=style&index=0&id=4c045cde&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c045cde",
  null
  
)

export default component.exports